import { Component, OnInit } from '@angular/core';
import { ChatbotFunService } from 'src/app/services/chatbot-fun.service';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-home-body',
  templateUrl: './home-body.component.html',
  styleUrls: ['./home-body.component.css']
})
export class HomeBodyComponent implements OnInit {

  constructor(private homeService: HomeService, public chatbotFunService: ChatbotFunService) { }

  ngOnInit() {
  }

  callMessagePage(){
    this.homeService.setCurrentPage('message');

  }
}
